var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68064 3.40625V7.11632C7.68064 8.09514 6.88689 8.88889 5.90807 8.88889H4.17543C3.19661 8.88889 2.40286 8.09514 2.40286 7.11632V3.40625C2.40286 3.25104 2.27682 3.125 2.12161 3.125H1.573C1.41779 3.125 1.29175 3.25104 1.29175 3.40625V7.20833C1.29175 8.75 2.54175 10 4.08341 10H6.00008C7.54175 10 8.79175 8.75 8.79175 7.20833V3.40625C8.79175 3.25104 8.66571 3.125 8.5105 3.125H7.96189C7.80668 3.125 7.68064 3.25104 7.68064 3.40625Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5973 0.867014V0.28125C5.5973 0.125694 5.47126 0 5.31605 0H4.76779C4.61223 0 4.48654 0.126042 4.48654 0.28125V0.866667C4.48654 0.944097 4.42369 1.0066 4.34661 1.0066H0.943484C0.790706 1.0066 0.666748 1.13056 0.666748 1.28333V1.84097C0.666748 1.99375 0.790706 2.11771 0.943484 2.11771H9.14001C9.29279 2.11771 9.41675 1.99375 9.41675 1.84097V1.28333C9.41675 1.13056 9.29279 1.0066 9.14001 1.0066H5.73758C5.66015 1.0066 5.59765 0.94375 5.59765 0.866667L5.5973 0.867014Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04164 7.1875C4.7347 7.1875 4.48608 6.93889 4.48608 6.63194V3.40347C4.48608 3.24965 4.61074 3.125 4.76456 3.125H5.31872C5.47254 3.125 5.5972 3.24965 5.5972 3.40347V6.63194C5.5972 6.93889 5.34858 7.1875 5.04164 7.1875Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.da2e501b82372619289e30a897bff814.svg";
export { ForwardRef as ReactComponent };